// extracted by mini-css-extract-plugin
export default {"SplashScreen":"Scene_SplashScreen__beYie","InfiniteSpinner":"Scene_InfiniteSpinner__1SQsA"};